import { useNavigate } from "react-router-dom";
import { DefaultService, InvoiceTemplateBodySchema } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Camelize } from "camelize-ts";
import snakify from "snakify-ts";
import { toaster } from "../components/toaster";

export const useInvoiceTemplateCreate = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationKey: ["invoiceTemplateCreate"],
    mutationFn: (data: Camelize<InvoiceTemplateBodySchema>) => {
      return DefaultService.fakturInvoicesViewsInvoicesTemplateCreate({
        requestBody: snakify({
          name: data.name,
          deliveryType: data.deliveryType,
          dueDays: data.dueDays,
          lines: data.lines.map((line) => ({
            invoicedQuantity: line.invoicedQuantity,
            vatRatePercentage: line.vatRatePercentage,
            description: line.description,
            netUnitAmount: line.netUnitAmount,
          })),
        }),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invoiceTemplateList"] });
      toaster.success({ title: "Fakturamal opprettet!" });
      navigate("/invoices/templates/");
    },
  });
};
